import { useEffect, useState } from "react";
import { DatePicker, Tooltip } from "antd";
import { RedoOutlined, SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import PropTypes from "prop-types";

const { RangePicker } = DatePicker;

const WeekSelect = ({
  loading,
  setLoading,
  setFlagsConsult,
  setFlagsGenerate,
  hasAllPermissionsChild1,
  setShopsData,
  refetchTrigger,
  onSearch,
  onDownload,
  onNavigateToRemitentes,
  onAddFaltantes,
  hasMissingDownloadPermission,
  hasSendersConfigPermission,
  hasMissingUpload,
  hasData,
}) => {
  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
  });

  const onChange = (dateString) => {
    setDate({
      startDate: dateString[0],
      endDate: dateString[1],
    });
  };

  useEffect(() => {
    onChange(["", ""]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetchTrigger]);

  const handleOnClick = async (isRefresh = false) => {
    if (isRefresh) {
      onChange(["", ""]);
      if (onSearch) onSearch("", "");
    } else {
      if (onSearch) onSearch(date.startDate, date.endDate);
    }
  };

  const handleOnDownload = () => {
    if (onDownload) onDownload(date.startDate, date.endDate);
  };

  const disabledDate = (current) => {
    const today = dayjs().endOf("day");
    let minDate = dayjs().subtract(52, "week").startOf("day");
    if (minDate.day() !== 1) {
      minDate = minDate.subtract((minDate.day() + 6) % 7, "day");
    }
    return current && (current > today || current < minDate);
  };

  return (
    <>
      <div className="filter-controls-container">
        <Tooltip title="Recargar">
          <button
            type="default"
            onClick={() => {
              handleOnClick(true);
            }}
            loading={loading}
            className="btn-toggle"
          >
            {loading ? null : (
              <RedoOutlined
                style={{
                  fontSize: "20px",
                }}
              />
            )}
          </button>
        </Tooltip>

        <RangePicker
          value={
            date.startDate && date.endDate ? [dayjs(date.startDate), dayjs(date.endDate)] : null
          }
          placeholder={["Fecha inicial", "Fecha final"]}
          onChange={(dates, dateString) => {
            onChange(dateString);
          }}
          allowClear={false}
          disabledDate={disabledDate}
          className="range-picker"
        />
      </div>

      <div className="filter-button-container">
        <Tooltip title={!date.startDate || !date.endDate ? "Elige rango de fecha." : ""}>
          <button
            className="btn-search"
            type="primary"
            onClick={() => {
              handleOnClick(false);
            }}
            disabled={!date.startDate || !date.endDate || loading}
            loading={loading}
          >
            <SearchOutlined />
          </button>
        </Tooltip>

        {(hasMissingDownloadPermission || hasAllPermissionsChild1) && (
          <Tooltip title={!hasData ? "Consulta por fechas para generar" : ""}>
            <button
              className="btn-toggle"
              type="primary"
              onClick={handleOnDownload}
              disabled={!hasData || loading}
              loading={loading}
            >
              CSV
            </button>
          </Tooltip>
        )}

        {(hasAllPermissionsChild1 || hasSendersConfigPermission) && (
          <button onClick={onNavigateToRemitentes} className="btn-toggle">
            Configurar remitentes
          </button>
        )}

        {(hasAllPermissionsChild1 || hasMissingUpload) && (
          <button onClick={onAddFaltantes} className="btn-toggle">
            Cargar Faltantes
          </button>
        )}
      </div>
    </>
  );
};

WeekSelect.propTypes = {
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  setFlagsConsult: PropTypes.func,
  setFlagsGenerate: PropTypes.func,
  hasAllPermissionsChild1: PropTypes.bool,
  setShopsData: PropTypes.func,
  refetchTrigger: PropTypes.bool,
  onSearch: PropTypes.func,
  onDownload: PropTypes.func,
  onNavigateToRemitentes: PropTypes.func,
  onAddFaltantes: PropTypes.func,
  hasMissingDownloadPermission: PropTypes.bool,
  hasSendersConfigPermission: PropTypes.bool,
  hasMissingUpload: PropTypes.bool,
  hasData: PropTypes.bool,
};

export default WeekSelect;
